import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  IFormbuilderFieldTypeConfiguration,
  ICustomIdInputFieldSettingsModel,
} from '../../../models/form-builder-types-configurations.model';
import {
  baseFieldUpdateFromSettingsFormModel,
  populatesPropsParseIntoSettingsFormModel,
  populatesPropsUpdateFromSettingsFormModel,
} from '../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import { IFormFieldsValidationModel } from '../../../models/form-fields-formly-validation.model';
import {
  parseIdConditionsValidatorParseFieldIntoModel,
  parsePopulatesFieldValidatorFormDataIntoModel,
  parseRequiredValidatorParseFieldIntoModel,
} from '../form-fields-formly-validations/form-fields-formly-validation-field-parse-to-model.util';
import {
  setRequiredValidatorUpdateFieldFromModel,
  setPopulatesFieldValidatorFormDataIntoField,
  setIdConditionsValidatorUpdateFieldFromModel,
} from '../form-fields-formly-validations/form-fields-formly-validation-field-set-from-model.util';
import { FormBuilderService } from '../../../services/form-builder.service';
import { IFormFieldsDisplayModel } from '../../../models/form-fields-formly-display.model';
import { parseFieldIntoDisplayFormModel } from '../form-fields-formly-display/form-fields-formly-display-field-parse-to-model.util';
import { setDisplayHideExpressionFromModel } from '../form-fields-formly-display/form-fields-formly-display-field-set-from-model.util';
import { getGenericCustomIdFieldTypeconfigurationConfig } from './shared.configuration';
import { nidChildNidResponseProps } from '../../../models/custom-id-input-responses.model';
import {
  setConditionalExpressionFromModel,
  setUtilConditionalExpressionFromModel,
} from '../form-fields-formly-validations/conditional-validations/fields-formly-conditional-validation-field-set-from-model.util';
import {
  parseConditionalValidatorsModelFromFieldIntoModel,
  parseUtilValidatorsModelFromFieldIntoModel,
} from '../form-fields-formly-validations/conditional-validations/fields-formly-conditional-validation-field-parse-to-model.util';

export const nidFieldGetConfigurationConfig = (
  formBuilderServiceInstance: FormBuilderService
): IFormbuilderFieldTypeConfiguration => {
  const config = getGenericCustomIdFieldTypeconfigurationConfig(
    formBuilderServiceInstance,
    [...Array.from(nidChildNidResponseProps)]
  );

  config.settings.formlyForm = [
    ...config.settings.formlyForm,
    {
      key: 'mixpanelEventAnalyticsConfig',
      id: 'mixpanelEventAnalyticsConfig',
      type: 'formly-group',
      props: { dragDisabled: false },
      fieldGroup: [
        {
          key: 'mixpanelEventAnalytics',
          type: 'checkbox',
          defaultValue: false,
          props: { label: 'Enable MixPanel Analytics', formCheck: 'switch' },
        },
      ],
    },
  ];

  return config;
};

export const nidFieldParseIntoSettingsFormModel = (
  nidField: FormlyFieldConfig
): ICustomIdInputFieldSettingsModel => {
  const model = populatesPropsParseIntoSettingsFormModel(nidField);
  model.mixpanelEventAnalyticsConfig = {
    mixpanelEventAnalytics: nidField.props?.['mixpanelEventAnalytics'],
  };
  return model;
};

export const nidFieldUpdateFromSettingsFormModel = (
  model: ICustomIdInputFieldSettingsModel,
  nidField: FormlyFieldConfig
): FormlyFieldConfig => {
  nidField = baseFieldUpdateFromSettingsFormModel(model, nidField);
  nidField = populatesPropsUpdateFromSettingsFormModel(model, nidField);

  const nidFieldFieldProps: Record<string, any> = nidField?.props
    ? { ...nidField?.props }
    : {};
  if (nidFieldFieldProps?.['idType'] === 'NID') {
    nidFieldFieldProps['usePrefetch'] = model.usePrefetch;
  } else {
    nidFieldFieldProps['usePrefetch'] = undefined;
  }
  nidField.props = { ...nidFieldFieldProps };
  return nidField;
};

export const nidFieldParseIntoValidationFormModel = (
  field: FormlyFieldConfig
): IFormFieldsValidationModel => {
  let model: IFormFieldsValidationModel = {};

  model = parseRequiredValidatorParseFieldIntoModel(model, field);
  model = parseIdConditionsValidatorParseFieldIntoModel(model, field);
  model = parsePopulatesFieldValidatorFormDataIntoModel(model, field);
  model = parseConditionalValidatorsModelFromFieldIntoModel(model, field);
  model = parseUtilValidatorsModelFromFieldIntoModel(model, field);

  return model;
};

export const nidFieldUpdateFromValidationFormModel = (
  model: IFormFieldsValidationModel,
  nidInput: FormlyFieldConfig
): FormlyFieldConfig => {
  nidInput = setRequiredValidatorUpdateFieldFromModel(model, nidInput);
  nidInput = setIdConditionsValidatorUpdateFieldFromModel(model, nidInput);
  nidInput = setPopulatesFieldValidatorFormDataIntoField(model, nidInput);
  nidInput = setConditionalExpressionFromModel(model, nidInput);
  nidInput = setUtilConditionalExpressionFromModel(model, nidInput);

  return nidInput;
};

export const nidFieldParseFieldIntoDisplayFormModel = (
  field: FormlyFieldConfig
): IFormFieldsDisplayModel => {
  return parseFieldIntoDisplayFormModel(field);
};

export const nidFieldUpdateFromDisplayFormModel = (
  model: IFormFieldsDisplayModel,
  field: FormlyFieldConfig
): FormlyFieldConfig => {
  return setDisplayHideExpressionFromModel(model, field);
};
